import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GlobalInfo, FPMessage, Severities, SourceSystem } from '../shared.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '../base.component';
import { SharedService } from '../shared.service';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from '../loader.service';
import { CapitalizeFirstPipe } from '../pipes/custom-pipes.pipe';
import { TechnicianJobService } from '../../technician/technician-jobs/technician-jobs.service';
import {
    RouteParams, ClosePopup, ChecklistModel, DynamicCheckListDetails, ControlsName, DynamicModel,
    DynamicSaveModel, ATextBox, NTextBoxData, DropDownData, OutputValue, CheckBoxData, DynamicData, SaveDynamicChecklist
} from '../../technician/technician-jobs/technician-jobs.models';

@Component({
    selector: 'dynamic-forms-checklist-popup',
    templateUrl: 'dynamic-forms-checklist.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./dynamic-forms-checklist.css']
})

export class DynamicFormsChecklistComponent extends BaseComponent implements OnInit {
    addattachment: boolean = false;
    @Input() woJobChecklistId: number;
    @Output() Close = new EventEmitter();
    @Input() submitButton: boolean;
    @Input() ChklistMastId: number;
    @Input() ChecklistName: string;
    @Input() WorkOrderId: number = 0;
    @Input() CustomerId: number = 0;
    @Input() WoJobId: number = 0;
    //Commmon model
    gi = new GlobalInfo;
    message = new FPMessage;
    popupClose = new ClosePopup;
    rp = new RouteParams;

    //form initialize
    frmDynamiCheckList: FormGroup;

    //model initialize
    checklistAll: ChecklistModel[] = [];
    dynamicCheckList: DynamicCheckListDetails[];
    //get Input Param
    AttchmentPop = new DynamicCheckListDetails;
    controlName: ControlsName[] = [
        { key: 25, value: "HD" },//header
        { key: 26, value: "AT" },//Alpha Numeric textbox
        { key: 27, value: "NT" },//number text box
        { key: 28, value: "DD" },//dropdown
        { key: 29, value: "CB" },//checkbox
        { key: 320, value: "QR" },//QrCode
        { key: 330, value: "SH" },//Sub Header
        { key: 329, value: "MT" },//Multi Line Textbox
        { key: 328, value: "CL" },//Checkbox List
        { key: 350, value: "DT" },//Date
        { key: 355, value: "LB" },//Label
        { key: 356, value: "RT" },//Rich text box
        { key: 352, value: "SF" },//Sub Form
        { key: 380, value: "GO" },//Geo Coordinates
        { key: 399, value: "TI" }//Date Time,
    ];
    dynamicModel: DynamicModel;
    //variable declare
    totalChecklist: number;
    isOpenDynamicChecklist: boolean;
    submitted: boolean;
    WoJobChecklistDetailId: number;
    ChklistDtlId: number;
    QuestionId: number;
    Question: string;
    ChklistMastIdd: number;
    jobid: number;
    wkid: number;
    StatusView: boolean;
    Ispopupopen: boolean = false;
    yearRange: string;
    constructor(
        protected sharedService: SharedService,
        protected translate: TranslateService,
        private _technicianJobService: TechnicianJobService,
        private route: ActivatedRoute,
        private loaderService: LoaderService,
    ) {

        super(sharedService, translate);
        this.gi = super.globalInfo();
        this.yearRange = sharedService.yearRange;
    }

    ngOnInit() {
        this.getRouteParams();
        this.frmDynamiCheckList = this.toFormGroup();
    }

    getRouteParams(): void {
        this.route.params.subscribe(params => {
            this.rp.WoJobId = this.WoJobId;
            this.rp.WorkOrderId = params['workOrderId'];
            this.rp.WoCategoryId = params['woCategoryId'];
            this.rp.TechnicianId = params['TechnicianId'];
            this.rp.WoNumber = params['WoNumber'];
        });
    }

    SetOptional(group: any, IsOptional: boolean, formconName: string, isParentQuetionId: number) {
        group[formconName] = ((IsOptional || isParentQuetionId > 0) ? new FormControl('') : new FormControl('', [Validators.required]));
    }
    /**End Question */
    toFormGroup() {
        let group: any = {};
        this.loaderService.show();
        this._technicianJobService.getDynamicCheckList(this.gi.CompanyId, this.woJobChecklistId, this.ChklistMastId, this.rp.WoJobId) //80
            .subscribe(s => {
                this.dynamicCheckList = s;
                this.loaderService.hide();
                if (this.dynamicCheckList != null && this.dynamicCheckList.length != 0) {
                    let k = 0;
                    this.dynamicCheckList.filter(f => !f.IsSubFormQuestion).map(m => {
                        m.formconName = m.WoJobChecklistDetailId + '' + (this.controlName.find(f => f.key == m.FieldTypeId).value);
                        m.ControlType = (this.controlName.find(f => f.key == m.FieldTypeId).value);
                        m.show = true;
                        m.IsSubFormQuestion = false;
                        k++;
                        if (m.FieldSourceId == 3) {
                            if (m.ParentQuestionId) {//If have Parant Question - Display Question & Answer
                                let gparantQuestion = this.dynamicCheckList.find(f => f.ChklistDtlId == m.ParentQuestionId);
                                let gparantQuestionAnswer: any;
                                if (gparantQuestion) {
                                    gparantQuestionAnswer = gparantQuestion.dropdownvalues.find(f => f.ChklistDdDtlId == m.ParentQuestionAnswerId);
                                    gparantQuestionAnswer = gparantQuestionAnswer ? gparantQuestionAnswer.ValueList : '';
                                }
                                m.SubFormParantQuestion = gparantQuestion ? gparantQuestion.Question + " : " + gparantQuestionAnswer : '';
                                m.show = false;
                            }
                            m.SubFormList.map(sm => {
                                if (sm.ParentQuestionId || m.ParentQuestionId)
                                    sm.show = false;
                                else
                                    sm.show = true;
                                sm.formconName = sm.WoJobChecklistDetailId + '' + (this.controlName.find(f => f.key == sm.FieldTypeId).value);
                                sm.ControlType = (this.controlName.find(f => f.key == sm.FieldTypeId).value);
                                sm.IsSubFormQuestion = true;
                                this.dynamicCheckList.splice(k, 0, sm);
                                k++;
                            });
                        }
                        return m;
                    });
                    this.toDynamicFormGroup();
                } else {
                    this.sharedService.notification.emit({
                        severity: Severities[3],
                        summary: CapitalizeFirstPipe.prototype.transform(Severities[3]),
                        detail: this.translate.instant("No Questions")
                    });
                    this.closePopup();
                }
            }, e => { this.loaderService.hide(); });
        return new FormGroup(group);
    }

    selectedId: number;
    toDynamicFormGroup() {
        let group: any = {};
        if (this.dynamicCheckList) {
            this.dynamicCheckList.forEach(f => {
                switch (f.FieldTypeId) {
                    case 25:
                        this.SetOptional(group, true, f.formconName, f.ParentQuestionId);
                        break;
                    case 26:
                        this.SetOptional(group, f.IsOptional, f.formconName, f.ParentQuestionId);
                        break;
                    case 320:
                        this.SetOptional(group, f.IsOptional, f.formconName, f.ParentQuestionId);
                        break;
                    case 27:
                        this.SetOptional(group, f.IsOptional, f.formconName, f.ParentQuestionId);
                        break;
                    case 28:
                        this.SetOptional(group, f.IsOptional, f.formconName, f.ParentQuestionId);
                        break;
                    case 29:
                        this.SetOptional(group, true, f.formconName, f.ParentQuestionId);
                        break;
                    case 328:
                        this.SetOptional(group, f.IsOptional, f.formconName, f.ParentQuestionId);
                        break;
                    case 329:
                        this.SetOptional(group, f.IsOptional, f.formconName, f.ParentQuestionId);
                        break;
                    case 330:
                        this.SetOptional(group, true, f.formconName, f.ParentQuestionId);
                        break;
                    case 350:
                        this.SetOptional(group, f.IsOptional, f.formconName, f.ParentQuestionId);
                        break;
                    case 355:
                        this.SetOptional(group, f.IsOptional, f.formconName, f.ParentQuestionId);
                        break;
                    case 356:
                        this.SetOptional(group, f.IsOptional, f.formconName, f.ParentQuestionId);
                        break;
                    case 352:
                        this.SetOptional(group, true, f.formconName, f.ParentQuestionId);
                        break;
                    case 380:
                        this.SetOptional(group, true, f.formconName, f.ParentQuestionId);
                        this.SetOptional(group, true, f.formconName + "_1", f.ParentQuestionId);
                        this.SetOptional(group, true, f.formconName + "_2", f.ParentQuestionId);
                        break;
                    case 399:
                        this.SetOptional(group, f.IsOptional, f.formconName, f.ParentQuestionId);
                        break;
                    default:
                        break;
                }
            });
            this.frmDynamiCheckList = new FormGroup(group);
            this.dynamicCheckList.forEach(f => {
                switch (f.FieldTypeId) {
                    case 26:
                        this.frmDynamiCheckList.controls[f.formconName].patchValue(f.TextValue);
                        break;
                    case 320:
                        this.frmDynamiCheckList.controls[f.formconName].patchValue(f.TextValue);
                        break;
                    case 27:
                        this.frmDynamiCheckList.controls[f.formconName].patchValue(f.TextValue);
                        break;
                    case 28:
                        this.frmDynamiCheckList.controls[f.formconName].patchValue((f.WoChklistDdId == 0 ||
                            f.WoChklistDdId == null) ? '' : f.WoChklistDdId);
                        let dldata: any[] = [];
                        dldata = f.dropdownvalues.filter(f => f.IsActive == 1);
                        //Dropdown Data if Inactive Master Level, take Inactive Also
                        if (f.WoChklistDdId) {
                            let inactivedl = f.dropdownvalues.filter(f => f.IsActive != 1);
                            inactivedl = inactivedl.filter(d => d.ChklistDdDtlId == f.WoChklistDdId);
                            inactivedl.forEach(g => { dldata.push(g); });
                        }
                        f.dropdownvalues = dldata;
                        this.showChildddl(f.WoChklistDdId, f.ChklistDtlId, f.SubFormParentId, f.IsSubFormQuestion, true);
                        break;
                    case 29:
                        this.frmDynamiCheckList.controls[f.formconName].patchValue(f.BooleanValue);
                        break;
                    case 328:
                        this.frmDynamiCheckList.controls[f.formconName].patchValue(f.MultiCheckBoxControl);
                        let cldata: any[] = [];
                        f.dropdownvalues.forEach(v => {
                            cldata.push({ label: v.ValueList, value: v.ChklistDdDtlId });
                        });
                        f.dropdownvalues = cldata;
                        this.showChildchkboxlist(f.MultiCheckBoxControl, f.ChklistDtlId, f.SubFormParentId, f.IsSubFormQuestion, true);
                        break;
                    case 329:
                        this.frmDynamiCheckList.controls[f.formconName].patchValue(f.TextValue);
                        break;
                    case 330:
                        this.frmDynamiCheckList.controls[f.formconName].patchValue(f.TextValue);
                        break;
                    case 350:
                        let a = !isNaN(Date.parse(f.DtValue));
                        this.frmDynamiCheckList.controls[f.formconName].patchValue(a ? (new Date(f.DtValue)) : f.DtValue);
                        break;
                    case 355:
                        this.frmDynamiCheckList.controls[f.formconName].patchValue(f.TextValue);
                        break;
                    case 356:
                        this.frmDynamiCheckList.controls[f.formconName].patchValue(f.TextValue);
                        break;
                    case 380:
                        this.frmDynamiCheckList.controls[f.formconName].patchValue(f.TextValue);
                        if (f.TextValue) {
                            let latlon = f.TextValue.split(',');
                            if (latlon.length == 2) {
                                this.frmDynamiCheckList.controls[f.formconName + "_1"].patchValue(latlon[0]);
                                this.frmDynamiCheckList.controls[f.formconName + "_2"].patchValue(latlon[1]);
                            }
                        }
                        break;
                    case 399:
                        let t = !isNaN(Date.parse(f.DtValue));
                        this.frmDynamiCheckList.controls[f.formconName].patchValue(t ? (new Date(f.DtValue)) : f.DtValue);
                        break;
                    default:
                        break;
                }
            });
        }
    }

    dynamicListModel: DynamicSaveModel[] = [];
    formData: any[] = [];
    saveModelList: DynamicSaveModel[] = [];
    saveModel: DynamicSaveModel;
    atextBox: ATextBox[] = [];
    ntextBox: NTextBoxData[] = [];
    dropDown: DropDownData[] = [];
    checkBox: CheckBoxData[] = [];
    dynamicData: DynamicData[] = [];
    // dynamicModel: DynamicCheckListDetails;

    onSubmit(model, frmValid?: boolean): boolean {
        this.submitted = true;
        let data = model;
        this.sharedService.getSystemSettingByIds(this.globalInfo().CompanyId, 152).subscribe(
            s => {
                let AllowFormSave = s.length > 0 ? s[0].SettingValue : "0";
                if ((frmValid && data) || AllowFormSave == "1") {
                    let attachmentCount = this.dynamicCheckList.filter(f => f.AllowAttachment == 2 && f.AttachmentCount == 0 && f.show == true);
                    if (attachmentCount.length > 0 && AllowFormSave != "1") {
                        this.sharedService.notification.emit({
                            severity: Severities[3],
                            summary: CapitalizeFirstPipe.prototype.transform(Severities[3]),
                            detail: this.translate.instant("ATTACHMENTREQUIREDFORM")
                        });
                        return false;
                    }

                    this.dynamicData = [];
                    for (var key in data) {
                        if (key != "" && key.split('_').length != 2) {
                            let kvalue = key.substring(key.length - 2, key.length);
                            let idKey = (+key.substring(0, key.length - 2));
                            if (kvalue)
                                this.dynamicData.push({ Value: data[key], Id: idKey });
                        }
                    }

                    if (this.dynamicCheckList && this.dynamicData) {
                        this.saveModelList = [];
                        this.dynamicData.map(m => {
                            this.saveModel = new DynamicSaveModel();
                            let d = this.dynamicCheckList.find(f => f.WoJobChecklistDetailId == m.Id);
                            let checkDetailId = d.WoJobChecklistDetailId;
                            this.saveModel.WoJobChecklistDetailId = checkDetailId;
                            this.saveModel.CompanyId = this.gi.CompanyId;
                            this.saveModel.WoJobId = this.rp.WoJobId;
                            this.saveModel.WoJobChklistId = d.WoJobChklistId;
                            this.saveModel.ChklistDtlId = d.ChklistDtlId;
                            this.saveModel.FieldTypeId = d.FieldTypeId;
                            this.saveModel.IsOptional = d.IsOptional;
                            this.saveModel.ChklistActiveDtl = d.ChklistActiveDtl;
                            this.saveModel.CFDropDownId = d.CFDropDownId;
                            this.saveModel.DtValue = d.DtValue;
                            this.saveModel.FieldSourceId = d.FieldSourceId;
                            this.saveModel.FieldId = d.FieldId;
                            this.saveModel.SubFormParentId = d.SubFormParentId;
                            this.saveModel.PrimaryEntityId = d.PrimaryEntityId;
                            let findValue = this.dynamicData.find(f => f.Id == m.Id).Value;
                            if (this.saveModel.FieldTypeId == 26 || this.saveModel.FieldTypeId == 27 || this.saveModel.FieldTypeId == 320 || this.saveModel.FieldTypeId == 329 || this.saveModel.FieldTypeId == 355 || this.saveModel.FieldTypeId == 356 || this.saveModel.FieldTypeId == 380)
                                this.saveModel.TextValue = findValue;
                            else
                                this.saveModel.TextValue = null;

                            if (this.saveModel.FieldTypeId == 29)
                                this.saveModel.BooleanValue = (+findValue);
                            else
                                this.saveModel.BooleanValue = 0;

                            if (this.saveModel.FieldTypeId == 28)
                                if (this.saveModel.FieldSourceId == 2) {
                                    this.saveModel.CFDropDownId = (+findValue);
                                    this.saveModel.WoChklistDdId = 0;
                                }
                                else {
                                    this.saveModel.CFDropDownId = 0;
                                    this.saveModel.WoChklistDdId = (+findValue);
                                }
                            else {
                                this.saveModel.CFDropDownId = 0;
                                this.saveModel.WoChklistDdId = 0;
                            }

                            if (this.saveModel.FieldTypeId == 328)
                                this.saveModel.MultiCheckBoxControl = (findValue);

                            if (this.saveModel.FieldTypeId == 350) {
                                let a = !isNaN(Date.parse(findValue));
                                if (a) this.saveModel.DtValue = new Date(findValue).toDateString();
                                else this.saveModel.DtValue = null;
                            }

                            if (this.saveModel.FieldTypeId == 399) {                        
                                let a = !isNaN(Date.parse(findValue));
                                if (a) {
                                    let date = new Date(findValue);
                                    let dateString = date.toDateString() + " " + date.getHours() + ":" + date.getMinutes();
                                    this.saveModel.DtValue = dateString;
                                }
                                else this.saveModel.DtValue = null;
                            }

                            this.saveModel.CreatedBy = this.gi.LoginId;
                            this.saveModel.CreatedBy = this.gi.LoginId;
                            this.saveModel.CreatedSourceId = SourceSystem.Web;
                            this.saveModel.UpdatedSourceId = SourceSystem.Web;
                            this.saveModel.ChklistMastId = d.ChklistMastId;
                            this.saveModelList.push(this.saveModel);
                        });

                        let data: SaveDynamicChecklist = {
                            Questions: this.saveModelList,
                            CommonData: {
                                CustomerId: this.CustomerId,
                                WorkOrderId: this.WorkOrderId,
                                WoJobId: this.WoJobId,
                                CompanyId: this.gi.CompanyId
                            }
                        }

                        this._technicianJobService.saveDynamicCheckList(data).subscribe(res => {
                            this.message = res.Message;
                            if (this.message.MessageCode == "1001" || this.message.MessageCode == "1002") {
                                this.sharedService.notification.emit({
                                    severity: Severities[this.message.Severity],
                                    summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                                    detail: this.translate.instant('CHECKLIST') + " " + this.translate.instant(this.message.MessageCode)
                                });
                                this.closePopup();
                                if (data.Questions.length > 0 && data.Questions.filter(f => f.FieldSourceId == 2))
                                    this._technicianJobService.updateCFDF.emit(true);
                            }
                            else {
                                this.sharedService.notification.emit({
                                    severity: Severities[this.message.Severity],
                                    summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                                    detail: this.translate.instant(this.message.MessageCode)
                                });
                                this.closePopup();
                            }
                            return true;
                        });
                    }
                    return true;
                }
                else
                    return false;
            },
            e => {
                return false;
            }
        );
        return true;
    }

    DecimalValidation(e) {
        if (e.keyCode == 48 || e.keyCode == 49 || e.keyCode == 50 || e.keyCode == 51 || e.keyCode == 52 || e.keyCode == 53
            || e.keyCode == 54 || e.keyCode == 55 || e.keyCode == 56 || e.keyCode == 57 || e.keyCode == 46) {
            return true;
        } else
            return false;
    }

    closePopup() {
        this.Close.emit();
    }

    showChildddl(obj: number, ChklistDtlId: number, SubFormParentId: number, IsSubFormQuestion: boolean, onLoad: boolean = false) {
        //Main Form
        if (IsSubFormQuestion == false) {
            // Main Question Hidden
            let mainQuestion = this.dynamicCheckList.filter(f => f.ParentQuestionId == ChklistDtlId && f.IsSubFormQuestion == false)
            mainQuestion.forEach(mQ => {
                mQ.show = false;
                this.removeValidator(mQ.formconName, mQ.IsOptional, mQ, onLoad);
                // Main Question Sub Form Questions Hidden
                if (mQ.FieldSourceId == 3) {
                    let subformList = this.dynamicCheckList.filter(f => f.IsSubFormQuestion == true && f.SubFormParentId == mQ.WoJobChecklistDetailId);
                    subformList.forEach(s => {
                        s.show = false;
                        this.removeValidator(s.formconName, s.IsOptional, s, onLoad);
                    });
                }

                // parant - child question 
                if (this.dynamicCheckList.filter(f => f.ParentQuestionId == mQ.ChklistDtlId).length > 0)
                    this.showChildddl(0, mQ.ChklistDtlId, mQ.SubFormParentId, mQ.IsSubFormQuestion, onLoad);

            });

            // Activate Child Questions - Main
            let dActive = this.dynamicCheckList.filter(f => f.ParentQuestionAnswerId == obj && f.ParentQuestionId == ChklistDtlId && f.IsSubFormQuestion == false);
            dActive.forEach(da => {
                da.show = true;
                this.setValidator(da.formconName, da.IsOptional);
                if (da.FieldSourceId == 3) {
                    let subformList = this.dynamicCheckList.filter(f => f.IsSubFormQuestion == true
                        && f.SubFormParentId == da.WoJobChecklistDetailId && (f.ParentQuestionId == 0 || f.ParentQuestionId == null));
                    subformList.forEach(s => {
                        s.show = true;
                        this.setValidator(s.formconName, s.IsOptional);
                    });
                }
            });
        }
        //Sub Form
        else {
            let SubFormQuestion = this.dynamicCheckList.filter(f => f.ParentQuestionId == ChklistDtlId && f.IsSubFormQuestion == true && f.SubFormParentId == SubFormParentId);
            SubFormQuestion.forEach(sf => {
                sf.show = false;
                this.removeValidator(sf.formconName, sf.IsOptional, sf, onLoad);
                if (this.dynamicCheckList.filter(f => f.ParentQuestionId == sf.ChklistDtlId).length > 0)
                    this.showChildddl(0, sf.ChklistDtlId, sf.SubFormParentId, sf.IsSubFormQuestion, onLoad);
            });

            // Activate Child Questions - Sub
            let sActive = this.dynamicCheckList.filter(f => f.ParentQuestionAnswerId == obj && f.ParentQuestionId == ChklistDtlId && f.IsSubFormQuestion == true && f.SubFormParentId == SubFormParentId);
            sActive.forEach(sa => {
                sa.show = true;
                this.setValidator(sa.formconName, sa.IsOptional);
            });
        }
    }

    showChildchkboxlist(obj: any, ChklistDtlId: number, SubFormParentId: number, IsSubFormQuestion: boolean, onLoad: boolean = false) {
        //Main Form 
        if (IsSubFormQuestion == false) {
            // Main Question Hidden
            let mainQuestion = this.dynamicCheckList.filter(f => f.ParentQuestionId == ChklistDtlId && f.IsSubFormQuestion == false)
            mainQuestion.forEach(mQ => {
                obj = ((obj && obj.value) ? obj.value : obj);
                if ((obj && obj.filter(g => g == mQ.ParentQuestionAnswerId).length == 0) || !obj) {
                    mQ.show = false;
                    this.removeValidator(mQ.formconName, mQ.IsOptional, mQ, onLoad);
                    if (mQ.FieldSourceId == 3) {
                        let subformList = this.dynamicCheckList.filter(f => f.IsSubFormQuestion == true && f.SubFormParentId == mQ.WoJobChecklistDetailId);
                        subformList.forEach(s => {
                            s.show = false;
                            this.removeValidator(s.formconName, s.IsOptional, s, onLoad);
                        });
                    }
                    if (this.dynamicCheckList.filter(f => f.ParentQuestionId == mQ.ChklistDtlId).length > 0)
                        this.showChildchkboxlist(0, mQ.ChklistDtlId, mQ.SubFormParentId, mQ.IsSubFormQuestion, onLoad);
                }
            });

            if (obj) {
                let data = [];
                data = (obj.value ? obj.value : obj);
                data.forEach(el => {
                    // Activate Child Questions - Main
                    let dActive = this.dynamicCheckList.filter(f => f.ParentQuestionAnswerId == el && f.ParentQuestionId == ChklistDtlId && f.IsSubFormQuestion == false);
                    dActive.forEach(da => {
                        da.show = true;
                        this.setValidator(da.formconName, da.IsOptional);
                        if (da.FieldSourceId == 3) {
                            let subformList = this.dynamicCheckList.filter(f => f.IsSubFormQuestion == true
                                && f.SubFormParentId == da.WoJobChecklistDetailId && (f.ParentQuestionId == 0 || f.ParentQuestionId == null));
                            subformList.forEach(s => {
                                s.show = true;
                                this.setValidator(s.formconName, s.IsOptional);
                            });
                        }
                    });
                });
            }
        }
        //Sub Form
        else {
            let SubFormQuestion = this.dynamicCheckList.filter(f => f.ParentQuestionId == ChklistDtlId && f.IsSubFormQuestion == true && f.SubFormParentId == SubFormParentId);
            SubFormQuestion.forEach(sf => {
                sf.show = false;
                this.removeValidator(sf.formconName, sf.IsOptional, sf, onLoad);
                if (this.dynamicCheckList.filter(f => f.ParentQuestionId == sf.ChklistDtlId).length > 0)
                    this.showChildchkboxlist(0, sf.ChklistDtlId, sf.SubFormParentId, sf.IsSubFormQuestion, onLoad);
            });

            if (obj) {
                let data = [];
                data = (obj.value ? obj.value : obj);
                data.forEach(el => {
                    // Activate Child Questions - Sub
                    let sActive = this.dynamicCheckList.filter(f => f.ParentQuestionAnswerId == el && f.ParentQuestionId == ChklistDtlId && f.IsSubFormQuestion == true && f.SubFormParentId == SubFormParentId);
                    sActive.forEach(sa => {
                        sa.show = true;
                        this.setValidator(sa.formconName, sa.IsOptional);
                    });
                });
            }
        }
    }

    setValidator(fomcontname: string, IsOptional: boolean) {
        if (!IsOptional) {
            this.frmDynamiCheckList.get(fomcontname).setValidators([Validators.required]);
            this.frmDynamiCheckList.get(fomcontname).updateValueAndValidity();
        }
    }

    removeValidator(fomcontname: string, IsOptional: boolean, obj: any, onLoad: boolean) {
        if (!IsOptional) {
            this.frmDynamiCheckList.get(fomcontname).clearValidators();
            this.frmDynamiCheckList.get(fomcontname).updateValueAndValidity();
        }
        if (obj.FieldSourceId != 2 && onLoad == false)
            this.frmDynamiCheckList.get(fomcontname).setValue("");
    }

    openAttachmentpopup(rowdata: DynamicCheckListDetails) {
        this.WoJobChecklistDetailId = rowdata.WoJobChecklistDetailId;
        this.ChklistDtlId = rowdata.ChklistDtlId;
        this.QuestionId = rowdata.QuestionId;
        this.Question = rowdata.Question;
        this.ChklistMastIdd = rowdata.ChklistMastId;
        this.jobid = rowdata.WoJobId;
        this.wkid = rowdata.WorkOrderId;
        this.StatusView = this.submitButton;
        super.openPopup();
        this.addattachment = true;
    }

    closesearch(value: OutputValue) {
        if (value.success == false) {
            let getquid = this.dynamicCheckList.findIndex(x => x.ChklistDtlId == value.QuestionId);
            this.dynamicCheckList[getquid].AttachmentCount = value.Count;
            super.closePopup();
            this.addattachment = false;
        }
        else {
            this.addattachment = true;
        }
    }

    rightpanel() {
        this.Ispopupopen = !this.Ispopupopen;
    }
}